import api from "./apiService";

const searchCpv = (key) => api.get(`search/${key}`);

const getCpv = (data, page = 0) => api.get(`searchingtree/${data}?page=${page}`);

const sendUserSearch = (data) => api.post("userSearch", data);

export { searchCpv, getCpv, sendUserSearch };
